import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Formik } from 'formik';
import { Typography } from '@mui/material';

import { IMainGoalModel } from '@common/models/Goals/MainGoal';
import { IGoalModel } from '@common/models/Goals/Goal';
import GoalItem from '../GoalItem';
import GoalsEditButton from '../EditButton';
import GoalsFormCreateItem from './CreateItem';
import {
	StyledGoalsForm,
	StyledGoalsItemsWrap,
	StyledGoalsTextField,
} from './styled';

interface PropsType {
	isEditing?: boolean;
	onSetIsEditing: (value: boolean) => () => void;
	mainGoalModel: IMainGoalModel;
}

function GoalsForm({ isEditing, onSetIsEditing, mainGoalModel }: PropsType) {
	const [deletedIds, setDeletedIds] = useState<number[]>([]);
	const handleSubmit = async (data: any) => {
		try {
			await Promise.all([
				mainGoalModel.save({
					title: data.title,
				}),
				mainGoalModel.addSteps(data.goals
					.flatMap((goal: any) => goal?.steps
						.filter((step: any) => !step?.id)
						.map((step: any) => ({ goal_id: goal.id, title: step.title })),
					),
				),
				deletedIds.length && mainGoalModel.removeSteps(deletedIds),
			]);
			setDeletedIds([]);
			await mainGoalModel.fetch();
			onSetIsEditing(false)();
		} catch (e) {
			console.error(e);
		}
	};

	return isEditing ? (
		<Formik
			onSubmit={handleSubmit}
			initialValues={{
				title: mainGoalModel.title || '',
				goals: mainGoalModel.goals || [],
			}}
		>
			<StyledGoalsForm>
				<StyledGoalsTextField name="title" multiline />
				<StyledGoalsItemsWrap>
					{!!mainGoalModel.goals.length && mainGoalModel?.goals
						.map((goal: IGoalModel, index: number) => (
							<GoalItem
								key={index}
								goalIndex={index}
								goal={goal}
								isEditing={isEditing}
								onClose={onSetIsEditing(false)}
								onDelete={(id: number) => setDeletedIds([...deletedIds, id])}
							/>
					))}
					{mainGoalModel?.goals?.length < 6 && (
						<GoalsFormCreateItem />
					)}
				</StyledGoalsItemsWrap>
				<GoalsEditButton isEditing={isEditing} onSetIsEditing={onSetIsEditing} />
			</StyledGoalsForm>
		</Formik>
	) : (
		<>
			<Typography variant="body1">
				{mainGoalModel.title}
			</Typography>
			<StyledGoalsItemsWrap>
				{!!mainGoalModel.goals.length && mainGoalModel.goals
					.map((goal: IGoalModel, index: number) => (
						<GoalItem
							key={index}
							goalIndex={index}
							isEditing={isEditing}
							onClose={onSetIsEditing(false)}
							goal={goal}
						/>
				))}
			</StyledGoalsItemsWrap>
			<GoalsEditButton isEditing={isEditing} onSetIsEditing={onSetIsEditing} />
		</>
	);
}

export default observer(GoalsForm);
